"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _ApiConnectUserToProviderResponseObject = _interopRequireDefault(require("../model/ApiConnectUserToProviderResponseObject"));
var _ApiDisconnectUserFromProviderResponseObject = _interopRequireDefault(require("../model/ApiDisconnectUserFromProviderResponseObject"));
var _ApiKeepAliveObject = _interopRequireDefault(require("../model/ApiKeepAliveObject"));
var _ApiRegisterUserObject = _interopRequireDefault(require("../model/ApiRegisterUserObject"));
var _ApiUserObject = _interopRequireDefault(require("../model/ApiUserObject"));
var _AuthParams = _interopRequireDefault(require("../model/AuthParams"));
var _ChangeEmailParams = _interopRequireDefault(require("../model/ChangeEmailParams"));
var _ChangePasswordParams = _interopRequireDefault(require("../model/ChangePasswordParams"));
var _CoreDisconnectUserFromProviderPostRequest = _interopRequireDefault(require("../model/CoreDisconnectUserFromProviderPostRequest"));
var _CoreGetResetPasswordEmailPost200Response = _interopRequireDefault(require("../model/CoreGetResetPasswordEmailPost200Response"));
var _CoreGetUnsubscribeEmailEmailPost200Response = _interopRequireDefault(require("../model/CoreGetUnsubscribeEmailEmailPost200Response"));
var _CoreLoginUserWithProviderPost200Response = _interopRequireDefault(require("../model/CoreLoginUserWithProviderPost200Response"));
var _DeleteAllTokensParams = _interopRequireDefault(require("../model/DeleteAllTokensParams"));
var _ErrorResponse = _interopRequireDefault(require("../model/ErrorResponse"));
var _ForgotPasswordParams = _interopRequireDefault(require("../model/ForgotPasswordParams"));
var _GetResetPasswordEmailParams = _interopRequireDefault(require("../model/GetResetPasswordEmailParams"));
var _GetUserEmailSubscriptionsCommonParams = _interopRequireDefault(require("../model/GetUserEmailSubscriptionsCommonParams"));
var _Language = _interopRequireDefault(require("../model/Language"));
var _LoginUserWithProviderParams = _interopRequireDefault(require("../model/LoginUserWithProviderParams"));
var _ProviderParams = _interopRequireDefault(require("../model/ProviderParams"));
var _RegisterParams = _interopRequireDefault(require("../model/RegisterParams"));
var _ResendActivationParams = _interopRequireDefault(require("../model/ResendActivationParams"));
var _ResendActivationWithProviderParams = _interopRequireDefault(require("../model/ResendActivationWithProviderParams"));
var _ResetPasswordParams = _interopRequireDefault(require("../model/ResetPasswordParams"));
var _UnsubscribeEmailParams = _interopRequireDefault(require("../model/UnsubscribeEmailParams"));
var _UpdateEmailSubscriptionsParams = _interopRequireDefault(require("../model/UpdateEmailSubscriptionsParams"));
var _VerifyAccountParams = _interopRequireDefault(require("../model/VerifyAccountParams"));
var _VerifyEmailParams = _interopRequireDefault(require("../model/VerifyEmailParams"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Manage My Pain API
 * This document provide full documentation for [ManagingLife](http://managinglife.com) API # Introduction Each API call only supports POST calls, and all parameters goes to body of POST request<br> Format of each API endpoint is `https://SERVER.managinglife.com/api/vVERSION/SERVICE/METHOD`   - **SERVER** could be one of: *dev*, *preprod*, *sync*.   - **VERSION** could be one of: *1*, *3*, *4*.   - **SERVICE** e.g. *core*, *sync*, *alerts*.   - **METHOD** e.g. *generate-report*, *login-user*, *update-records*.  Any parameter that is not marked as required can be null or omitted. # Client libraries We also provide several client libraries which were auto-generated using swagger-codegen.   - [JavaScript](/codegen/javascript)   - [Java](/codegen/java)   - [PHP](/codegen/php)   - [Objective C](/codegen/objc) # Authentication <!-- ReDoc-Inject: <security-definitions> --> 
 *
 * The version of the OpenAPI document: 4.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
* AuthCalls service.
* @module api/AuthCallsApi
* @version 4.0.0
*/
var AuthCallsApi = exports["default"] = /*#__PURE__*/function () {
  /**
  * Constructs a new AuthCallsApi. 
  * @alias module:api/AuthCallsApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function AuthCallsApi(apiClient) {
    _classCallCheck(this, AuthCallsApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * change-email
   * Change email. Only authenticated user can call this method. <br> User will have to confirm email change by following link sent to his old email.
   * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
   * @param {module:model/ChangeEmailParams} params 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
   */
  return _createClass(AuthCallsApi, [{
    key: "coreChangeEmailPostWithHttpInfo",
    value: function coreChangeEmailPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreChangeEmailPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreChangeEmailPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/core/change-email', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * change-email
     * Change email. Only authenticated user can call this method. <br> User will have to confirm email change by following link sent to his old email.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ChangeEmailParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "coreChangeEmailPost",
    value: function coreChangeEmailPost(Accept_Language, params) {
      return this.coreChangeEmailPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * change-password
     * Change `password`. Only an authenticated user can call this method.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ChangePasswordParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "coreChangePasswordPostWithHttpInfo",
    value: function coreChangePasswordPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreChangePasswordPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreChangePasswordPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/core/change-password', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * change-password
     * Change `password`. Only an authenticated user can call this method.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ChangePasswordParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "coreChangePasswordPost",
    value: function coreChangePasswordPost(Accept_Language, params) {
      return this.coreChangePasswordPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * connect-user-to-provider
     * Connect user account to provider's account via front-end.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ProviderParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApiConnectUserToProviderResponseObject} and HTTP response
     */
  }, {
    key: "coreConnectUserToProviderPostWithHttpInfo",
    value: function coreConnectUserToProviderPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreConnectUserToProviderPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreConnectUserToProviderPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApiConnectUserToProviderResponseObject["default"];
      return this.apiClient.callApi('/core/connect-user-to-provider', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * connect-user-to-provider
     * Connect user account to provider's account via front-end.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ProviderParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApiConnectUserToProviderResponseObject}
     */
  }, {
    key: "coreConnectUserToProviderPost",
    value: function coreConnectUserToProviderPost(Accept_Language, params) {
      return this.coreConnectUserToProviderPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-all-tokens
     * Delete ALL tokens associated with a user. Only an authenticated user can call this method.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeleteAllTokensParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "coreDeleteAllTokensPostWithHttpInfo",
    value: function coreDeleteAllTokensPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreDeleteAllTokensPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreDeleteAllTokensPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/core/delete-all-tokens', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-all-tokens
     * Delete ALL tokens associated with a user. Only an authenticated user can call this method.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/DeleteAllTokensParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "coreDeleteAllTokensPost",
    value: function coreDeleteAllTokensPost(Accept_Language, params) {
      return this.coreDeleteAllTokensPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * delete-user(current)
     * Delete current user account 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing HTTP response
     */
  }, {
    key: "coreDeleteUserPostWithHttpInfo",
    value: function coreDeleteUserPostWithHttpInfo(Accept_Language) {
      var postBody = null;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreDeleteUserPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;
      return this.apiClient.callApi('/core/delete-user', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * delete-user(current)
     * Delete current user account 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}
     */
  }, {
    key: "coreDeleteUserPost",
    value: function coreDeleteUserPost(Accept_Language) {
      return this.coreDeleteUserPostWithHttpInfo(Accept_Language).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * disconnect-user-from-provider
     * Disconnect user account from `provider` via front-end and all `provider` tokens will be invalidated.  If the user is currently logged in through the `provider`, they will need to re-authenticate using their credentials. If password is not set, an error will be returned.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CoreDisconnectUserFromProviderPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApiDisconnectUserFromProviderResponseObject} and HTTP response
     */
  }, {
    key: "coreDisconnectUserFromProviderPostWithHttpInfo",
    value: function coreDisconnectUserFromProviderPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreDisconnectUserFromProviderPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreDisconnectUserFromProviderPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApiDisconnectUserFromProviderResponseObject["default"];
      return this.apiClient.callApi('/core/disconnect-user-from-provider', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * disconnect-user-from-provider
     * Disconnect user account from `provider` via front-end and all `provider` tokens will be invalidated.  If the user is currently logged in through the `provider`, they will need to re-authenticate using their credentials. If password is not set, an error will be returned.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/CoreDisconnectUserFromProviderPostRequest} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApiDisconnectUserFromProviderResponseObject}
     */
  }, {
    key: "coreDisconnectUserFromProviderPost",
    value: function coreDisconnectUserFromProviderPost(Accept_Language, params) {
      return this.coreDisconnectUserFromProviderPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * forgot-password
     * Send mail with link for changing `password` to provided email. It will not return error even if account not found. Error will be thrown only if email not provided or email sending doesn't work.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ForgotPasswordParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "coreForgotPasswordPostWithHttpInfo",
    value: function coreForgotPasswordPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreForgotPasswordPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreForgotPasswordPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/core/forgot-password', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * forgot-password
     * Send mail with link for changing `password` to provided email. It will not return error even if account not found. Error will be thrown only if email not provided or email sending doesn't work.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ForgotPasswordParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "coreForgotPasswordPost",
    value: function coreForgotPasswordPost(Accept_Language, params) {
      return this.coreForgotPasswordPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-reset-password-email
     * If provided valid password token then it will return user email but the most characters will be replaced by asterisks. If password token not valid API call will return 1018 error.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/GetResetPasswordEmailParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CoreGetResetPasswordEmailPost200Response} and HTTP response
     */
  }, {
    key: "coreGetResetPasswordEmailPostWithHttpInfo",
    value: function coreGetResetPasswordEmailPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreGetResetPasswordEmailPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreGetResetPasswordEmailPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _CoreGetResetPasswordEmailPost200Response["default"];
      return this.apiClient.callApi('/core/get-reset-password-email', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-reset-password-email
     * If provided valid password token then it will return user email but the most characters will be replaced by asterisks. If password token not valid API call will return 1018 error.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/GetResetPasswordEmailParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CoreGetResetPasswordEmailPost200Response}
     */
  }, {
    key: "coreGetResetPasswordEmailPost",
    value: function coreGetResetPasswordEmailPost(Accept_Language, params) {
      return this.coreGetResetPasswordEmailPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-translation
     * Issues all translation strings from the server
     * @param {module:model/String} app 
     * @param {Object} opts Optional parameters
     * @param {module:model/Language} [lang] If provided, then translations for that language will be returned, otherwise - English translations will be returned by default.
     * @param {module:model/Number} [include_fields] If set to 1, then section fields translations will be also included into response.
     * @param {Number} [institution] If provided, then institution-specific translations will be also included into response.
     * @param {module:model/Number} [institution_fields_only] If set to 1, then only institution-specific translations will returned from the server.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object.<String, {String: String}>} and HTTP response
     */
  }, {
    key: "coreGetTranslationGetWithHttpInfo",
    value: function coreGetTranslationGetWithHttpInfo(app, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'app' is set
      if (app === undefined || app === null) {
        throw new Error("Missing the required parameter 'app' when calling coreGetTranslationGet");
      }
      var pathParams = {};
      var queryParams = {
        'app': app,
        'lang': opts['lang'],
        'include_fields': opts['include_fields'],
        'institution': opts['institution'],
        'institution_fields_only': opts['institution_fields_only']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = {
        'String': 'String'
      };
      return this.apiClient.callApi('/core/get-translation', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-translation
     * Issues all translation strings from the server
     * @param {module:model/String} app 
     * @param {Object} opts Optional parameters
     * @param {module:model/Language} opts.lang If provided, then translations for that language will be returned, otherwise - English translations will be returned by default.
     * @param {module:model/Number} opts.include_fields If set to 1, then section fields translations will be also included into response.
     * @param {Number} opts.institution If provided, then institution-specific translations will be also included into response.
     * @param {module:model/Number} opts.institution_fields_only If set to 1, then only institution-specific translations will returned from the server.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object.<String, {String: String}>}
     */
  }, {
    key: "coreGetTranslationGet",
    value: function coreGetTranslationGet(app, opts) {
      return this.coreGetTranslationGetWithHttpInfo(app, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-unsubscribe-email-email
     * Shows email which will be unsubscribed by the token
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/UnsubscribeEmailParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CoreGetUnsubscribeEmailEmailPost200Response} and HTTP response
     */
  }, {
    key: "coreGetUnsubscribeEmailEmailPostWithHttpInfo",
    value: function coreGetUnsubscribeEmailEmailPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreGetUnsubscribeEmailEmailPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreGetUnsubscribeEmailEmailPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _CoreGetUnsubscribeEmailEmailPost200Response["default"];
      return this.apiClient.callApi('/core/get-unsubscribe-email-email', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-unsubscribe-email-email
     * Shows email which will be unsubscribed by the token
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/UnsubscribeEmailParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CoreGetUnsubscribeEmailEmailPost200Response}
     */
  }, {
    key: "coreGetUnsubscribeEmailEmailPost",
    value: function coreGetUnsubscribeEmailEmailPost(Accept_Language, params) {
      return this.coreGetUnsubscribeEmailEmailPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * get-user-email-subscriptions
     * Get all user email subscriptions. Returns all valid email categories for user
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Array.<module:model/GetUserEmailSubscriptionsCommonParams>} and HTTP response
     */
  }, {
    key: "coreGetUserEmailSubscriptionsPostWithHttpInfo",
    value: function coreGetUserEmailSubscriptionsPostWithHttpInfo(Accept_Language) {
      var postBody = null;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreGetUserEmailSubscriptionsPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [_GetUserEmailSubscriptionsCommonParams["default"]];
      return this.apiClient.callApi('/core/get-user-email-subscriptions', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * get-user-email-subscriptions
     * Get all user email subscriptions. Returns all valid email categories for user
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Array.<module:model/GetUserEmailSubscriptionsCommonParams>}
     */
  }, {
    key: "coreGetUserEmailSubscriptionsPost",
    value: function coreGetUserEmailSubscriptionsPost(Accept_Language) {
      return this.coreGetUserEmailSubscriptionsPostWithHttpInfo(Accept_Language).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * keep-alive
     * Keeps token alive. Returns updated expiration UNIX timestamp in seconds. Depending on the `token_type`, value can be increased by 6 minutes (`secure-web`), 16 minutes (`web`) and 20160 minutes (for other token types).
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApiKeepAliveObject} and HTTP response
     */
  }, {
    key: "coreKeepAlivePostWithHttpInfo",
    value: function coreKeepAlivePostWithHttpInfo(Accept_Language) {
      var postBody = null;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreKeepAlivePost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _ApiKeepAliveObject["default"];
      return this.apiClient.callApi('/core/keep-alive', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * keep-alive
     * Keeps token alive. Returns updated expiration UNIX timestamp in seconds. Depending on the `token_type`, value can be increased by 6 minutes (`secure-web`), 16 minutes (`web`) and 20160 minutes (for other token types).
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApiKeepAliveObject}
     */
  }, {
    key: "coreKeepAlivePost",
    value: function coreKeepAlivePost(Accept_Language) {
      return this.coreKeepAlivePostWithHttpInfo(Accept_Language).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * login-user
     * Authenticate user with specified `username` OR `email` combined with `password` OR `prev_token`.<br> Returns `token` which should be used for every API call 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AuthParams} params 
     * @param {Object} opts Optional parameters
     * @param {String} [Timezone] Timezone of the user's local environment.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApiUserObject} and HTTP response
     */
  }, {
    key: "coreLoginUserPostWithHttpInfo",
    value: function coreLoginUserPostWithHttpInfo(Accept_Language, params, opts) {
      opts = opts || {};
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreLoginUserPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreLoginUserPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language,
        'Timezone': opts['Timezone']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApiUserObject["default"];
      return this.apiClient.callApi('/core/login-user', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * login-user
     * Authenticate user with specified `username` OR `email` combined with `password` OR `prev_token`.<br> Returns `token` which should be used for every API call 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/AuthParams} params 
     * @param {Object} opts Optional parameters
     * @param {String} opts.Timezone Timezone of the user's local environment.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApiUserObject}
     */
  }, {
    key: "coreLoginUserPost",
    value: function coreLoginUserPost(Accept_Language, params, opts) {
      return this.coreLoginUserPostWithHttpInfo(Accept_Language, params, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * login-user-with-provider
     * Authenticate user with specified `provider` and `access_token` received by front-end from that provider.<br> If provider account is not currently associated with any ManagingLife account, one will be created.<br> If the provider's profile does not include an email address, then the `email` parameter is required otherwise an error will be thrown.<br> Returns `token`, which should be used for every API call. 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/LoginUserWithProviderParams} params 
     * @param {Object} opts Optional parameters
     * @param {String} [Timezone] Timezone of the user's local environment.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/CoreLoginUserWithProviderPost200Response} and HTTP response
     */
  }, {
    key: "coreLoginUserWithProviderPostWithHttpInfo",
    value: function coreLoginUserWithProviderPostWithHttpInfo(Accept_Language, params, opts) {
      opts = opts || {};
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreLoginUserWithProviderPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreLoginUserWithProviderPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language,
        'Timezone': opts['Timezone']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _CoreLoginUserWithProviderPost200Response["default"];
      return this.apiClient.callApi('/core/login-user-with-provider', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * login-user-with-provider
     * Authenticate user with specified `provider` and `access_token` received by front-end from that provider.<br> If provider account is not currently associated with any ManagingLife account, one will be created.<br> If the provider's profile does not include an email address, then the `email` parameter is required otherwise an error will be thrown.<br> Returns `token`, which should be used for every API call. 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/LoginUserWithProviderParams} params 
     * @param {Object} opts Optional parameters
     * @param {String} opts.Timezone Timezone of the user's local environment.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/CoreLoginUserWithProviderPost200Response}
     */
  }, {
    key: "coreLoginUserWithProviderPost",
    value: function coreLoginUserWithProviderPost(Accept_Language, params, opts) {
      return this.coreLoginUserWithProviderPostWithHttpInfo(Accept_Language, params, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * register-user
     * Register new account with specified `username`, `email` and `password` parameters.<br> Account should be activated by clicking the link sent via email after creation. <br> If `institution` and `study_id` parameters are provided as well, then User will be automatically joined to the Institution after successful registration. <br> If provided only `institution` without `study_id` and institution has study_id validation disabled, User will be automatically joined to the Institution with `uid` instead of `study_id`. <br> If `activation_code` is provided and valid - user account will be automatically activated after registration. UTM parameters (_utm_source_, _utm_medium_, _utm_campaign_) are optinal, and used for GA tracking on some Institutions Landing pages. 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/RegisterParams} params 
     * @param {Object} opts Optional parameters
     * @param {String} [Timezone] Timezone of the user's local environment.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ApiRegisterUserObject} and HTTP response
     */
  }, {
    key: "coreRegisterUserPostWithHttpInfo",
    value: function coreRegisterUserPostWithHttpInfo(Accept_Language, params, opts) {
      opts = opts || {};
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreRegisterUserPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreRegisterUserPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language,
        'Timezone': opts['Timezone']
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ApiRegisterUserObject["default"];
      return this.apiClient.callApi('/core/register-user', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * register-user
     * Register new account with specified `username`, `email` and `password` parameters.<br> Account should be activated by clicking the link sent via email after creation. <br> If `institution` and `study_id` parameters are provided as well, then User will be automatically joined to the Institution after successful registration. <br> If provided only `institution` without `study_id` and institution has study_id validation disabled, User will be automatically joined to the Institution with `uid` instead of `study_id`. <br> If `activation_code` is provided and valid - user account will be automatically activated after registration. UTM parameters (_utm_source_, _utm_medium_, _utm_campaign_) are optinal, and used for GA tracking on some Institutions Landing pages. 
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/RegisterParams} params 
     * @param {Object} opts Optional parameters
     * @param {String} opts.Timezone Timezone of the user's local environment.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ApiRegisterUserObject}
     */
  }, {
    key: "coreRegisterUserPost",
    value: function coreRegisterUserPost(Accept_Language, params, opts) {
      return this.coreRegisterUserPostWithHttpInfo(Accept_Language, params, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * resend-activation
     * Resend activation link to provided `email`
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ResendActivationParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "coreResendActivationPostWithHttpInfo",
    value: function coreResendActivationPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreResendActivationPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreResendActivationPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/core/resend-activation', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * resend-activation
     * Resend activation link to provided `email`
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ResendActivationParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "coreResendActivationPost",
    value: function coreResendActivationPost(Accept_Language, params) {
      return this.coreResendActivationPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * resend-activation-with-provider
     * Resend activation link to provided `email`
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ResendActivationWithProviderParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "coreResendActivationWithProviderPostWithHttpInfo",
    value: function coreResendActivationWithProviderPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreResendActivationWithProviderPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreResendActivationWithProviderPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/core/resend-activation-with-provider', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * resend-activation-with-provider
     * Resend activation link to provided `email`
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ResendActivationWithProviderParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "coreResendActivationWithProviderPost",
    value: function coreResendActivationWithProviderPost(Accept_Language, params) {
      return this.coreResendActivationWithProviderPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * reset-password
     * API call for changing password.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ResetPasswordParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "coreResetPasswordPostWithHttpInfo",
    value: function coreResetPasswordPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreResetPasswordPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreResetPasswordPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/core/reset-password', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * reset-password
     * API call for changing password.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/ResetPasswordParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "coreResetPasswordPost",
    value: function coreResetPasswordPost(Accept_Language, params) {
      return this.coreResetPasswordPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * unsubscribe-email
     * Unsubscribe user from a specified type of emails
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/UnsubscribeEmailParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "coreUnsubscribeEmailPostWithHttpInfo",
    value: function coreUnsubscribeEmailPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreUnsubscribeEmailPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreUnsubscribeEmailPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/core/unsubscribe-email', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * unsubscribe-email
     * Unsubscribe user from a specified type of emails
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/UnsubscribeEmailParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "coreUnsubscribeEmailPost",
    value: function coreUnsubscribeEmailPost(Accept_Language, params) {
      return this.coreUnsubscribeEmailPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * update-email-subscriptions
     * Update email subscriptions statuses
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {Array.<module:model/UpdateEmailSubscriptionsParams>} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "coreUpdateEmailSubscriptionsPostWithHttpInfo",
    value: function coreUpdateEmailSubscriptionsPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreUpdateEmailSubscriptionsPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreUpdateEmailSubscriptionsPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = ['token'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/core/update-email-subscriptions', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * update-email-subscriptions
     * Update email subscriptions statuses
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {Array.<module:model/UpdateEmailSubscriptionsParams>} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "coreUpdateEmailSubscriptionsPost",
    value: function coreUpdateEmailSubscriptionsPost(Accept_Language, params) {
      return this.coreUpdateEmailSubscriptionsPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * verify-account
     * Activate account using `account_token`. This token generated during registration or via API calls `resend-activation` or `resend-activation-with-provider`. This token is valid during 7 days after generation.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/VerifyAccountParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "coreVerifyAccountPostWithHttpInfo",
    value: function coreVerifyAccountPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreVerifyAccountPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreVerifyAccountPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/core/verify-account', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * verify-account
     * Activate account using `account_token`. This token generated during registration or via API calls `resend-activation` or `resend-activation-with-provider`. This token is valid during 7 days after generation.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/VerifyAccountParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "coreVerifyAccountPost",
    value: function coreVerifyAccountPost(Accept_Language, params) {
      return this.coreVerifyAccountPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * verify-email
     * Change email and username(if username=old_email) using `email_token`. This token generated during change-email api-call. This token expiration is controlled via \"Email token expiration (in days)\" field on LCS Settings form.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/VerifyEmailParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/ErrorResponse} and HTTP response
     */
  }, {
    key: "coreVerifyEmailPostWithHttpInfo",
    value: function coreVerifyEmailPostWithHttpInfo(Accept_Language, params) {
      var postBody = params;
      // verify the required parameter 'Accept_Language' is set
      if (Accept_Language === undefined || Accept_Language === null) {
        throw new Error("Missing the required parameter 'Accept_Language' when calling coreVerifyEmailPost");
      }
      // verify the required parameter 'params' is set
      if (params === undefined || params === null) {
        throw new Error("Missing the required parameter 'params' when calling coreVerifyEmailPost");
      }
      var pathParams = {};
      var queryParams = {};
      var headerParams = {
        'Accept-Language': Accept_Language
      };
      var formParams = {};
      var authNames = [];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _ErrorResponse["default"];
      return this.apiClient.callApi('/core/verify-email', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * verify-email
     * Change email and username(if username=old_email) using `email_token`. This token generated during change-email api-call. This token expiration is controlled via \"Email token expiration (in days)\" field on LCS Settings form.
     * @param {module:model/Language} Accept_Language Language of the user's local environment, which should be included in every API call.  The parameter follows [IETF BCP 47](http://tools.ietf.org/html/bcp47) for identifying language. It is always comprised of a two-letter language code ([ISO 639-1](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes)). This is optionally followed by a dash and a four-letter script code ([ISO 15924](http://unicode.org/iso15924/iso15924-codes.html)) if applicable.
     * @param {module:model/VerifyEmailParams} params 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/ErrorResponse}
     */
  }, {
    key: "coreVerifyEmailPost",
    value: function coreVerifyEmailPost(Accept_Language, params) {
      return this.coreVerifyEmailPostWithHttpInfo(Accept_Language, params).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
}();